<template>
  <div>
    <title>基本信息</title>
    <section class="mainDet" v-loading="isLoad">
        <!--S 基本信息表单-->
        <el-form :model="checkForm" :rules="rules" label-width="150px" class="comForm" :disabled="operate == 'detail'">
            <el-row class="mainWrap widthAuto">
                <!--S 基本信息-->
                <el-col :span="11">
                    <div class="grid-content">
                        <p class="commonTit flexBet">
                          <b>基本信息</b>
                          <em v-if="checkForm.openid || checkForm.bwxlogin">
                            <el-tag type="success" plain v-if="checkForm.openid">已绑微信</el-tag>
                            <el-tag type="primary" plain v-if="checkForm.bwxlogin">支持微信登录</el-tag>
                          </em>
                        </p>
                        <el-form-item label="店员账号" prop="username"> 
                            <div class="fixNum" :class="{'fixBg':operate == 'detail'}">
                                <span>{{qydm}}</span>
                                <el-input v-model="checkForm.username" clearable maxlength="12" @blur="checkFlowUsername" placeholder="为固定前缀"></el-input>
                            </div>
                        </el-form-item>
                        <el-form-item label="登录密码" prop="pwd" v-if="operate == 'add'" > 
                            <el-input :show-password="showPassword" v-model="checkForm.pwd" clearable maxlength="16"  placeholder="请输入内容"></el-input>
                        </el-form-item>
                        <el-form-item label="登录密码"  v-else :show-message="false"> 
                            <el-input :show-password="showPassword" v-model="checkForm.pwd" clearable maxlength="16"  placeholder="请输入内容"></el-input>
                        </el-form-item>
                         <!-- 开通登录短信验证时展示 -->
                        <el-form-item label="手机号码" prop="mobile" required v-if="ischeckcodeoflogin==1 && checkForm.ischeckcode" key="mobRequired" class="checkIpt"> 
                            <el-input v-model="checkForm.mobile" clearable maxlength="11" placeholder="请输入手机号码"></el-input>
                            <el-checkbox v-model="checkForm.ischeckcode" class="msgCheck">短信验证登录</el-checkbox>
                        </el-form-item>
                        <el-form-item label="手机号码" prop="mobile" v-if="ischeckcodeoflogin==1 && !checkForm.ischeckcode" key="mobnoRequired" class="checkIpt"> 
                            <el-input v-model="checkForm.mobile" clearable maxlength="11" placeholder="请输入手机号码"></el-input>
                            <el-checkbox v-model="checkForm.ischeckcode" class="msgCheck">短信验证登录</el-checkbox>
                        </el-form-item>
                        <el-form-item label="服务状态">
                            <el-switch :value="checkForm.status ? true : false" @change="statusChange" :width="45" class="isSwitch" :active-text="checkForm.status?'启':'禁'">
                            </el-switch>
                        </el-form-item>
                        <el-form-item label="联系人" prop="linkman" > 
                            <el-input v-model="checkForm.linkman" maxlength="20" clearable  placeholder="请输入联系人姓名"></el-input>
                        </el-form-item>
                        <el-form-item label="手机号码" prop="mobile" class="defineRow" v-if="ischeckcodeoflogin!=1"> 
                            <el-input v-model="checkForm.mobile" clearable maxlength="11" placeholder="请输入手机号码"></el-input>
                            <div class="btnRight">
                              <span class="kuang"></span>
                              <em>至少填写一个</em>
                            </div>
                        </el-form-item>
                        <el-form-item label="固话号码" prop="tel"> 
                            <el-input v-model="checkForm.tel" clearable maxlength="16" placeholder="请输入固话号码"></el-input>
                        </el-form-item>   
                        <el-form-item label="详细地址" prop="pcdinfo">
                            <ProvincesOrCity
                              v-model="checkForm.pcdinfo"
                              :valueType="'nv'"
                              :level="2"
                              :initCode="'0'"
                              :placeholder="'请选择省市区'">
                          </ProvincesOrCity>
                        </el-form-item>
                        <el-form-item label=" " prop="addrdet">
                            <el-input type="textarea" v-model="checkForm.addrdet" placeholder="输入详细地址，如门牌号，不少于5个字" clearable maxlength="50" minlength="5" show-word-limit></el-input>
                        </el-form-item>
                    </div>
                </el-col>
                <!--E 基本信息-->
                <el-col :span="2"></el-col>
                <!--S 权限设置-->
                <el-col :span="11">
                    <div class="grid-content">
                        <p class="commonTit"><b>权限设置</b></p>
                        <!-- <el-form-item label-width="0" v-if="userInfoMd.bsharemember"> 
                            <el-checkbox :value="checkForm.bsharemember ? true : false" @change="bsharememberChange">可查看企业所有会员</el-checkbox>
                        </el-form-item> -->
                        <el-form-item label-width="0" class="flexUI allWidth" >
                          <span>
                              <el-checkbox v-if="userInfoMd.isopensale" :value="checkForm.isopensale ? true : false" @change="isopensaleChange">销售业务权限</el-checkbox>
                              <el-checkbox v-if="userInfoMd.issalebindcard" :value="checkForm.issalebindcard? true : false" @change="issalebindcardChange">销售绑卡权限</el-checkbox>
                          </span>
                        </el-form-item>
                        <!-- <el-form-item label-width="0">
                          <el-checkbox v-if="userInfoMd.isopeninvoice" :value="checkForm.isopeninvoice ? true : false" @change="isopeninvoiceChange">数据报表权限</el-checkbox>
                        </el-form-item> -->
                        <el-form-item label-width="0" v-if="userInfoMd.isopenpurinvgoods||userInfoMd.isopencresaler" class="allWidth"> 
                           <el-checkbox v-if="userInfoMd.isopenpurinvgoods" :value="checkForm.isopenpurinvgoods ? true : false" @change="isopenpurinvgoodsChange">开票商品采购权限</el-checkbox>
                          <el-checkbox v-if="userInfoMd.isopencresaler" :value="checkForm.isopencresaler ? true : false" @change="isopencresalerChange">销售方管理权限</el-checkbox>
                        </el-form-item>
                        <!-- <el-form-item label-width="0" v-if="userInfoMd.cardpower||userInfoMd.ecardpower"> 
                            <el-checkbox v-if="userInfoMd.cardpower" :value="checkForm.cardpower ? true : false" @change="cardpowerChange">券卡操作权限</el-checkbox>
                            <el-checkbox v-if="userInfoMd.ecardpower" :value="checkForm.ecardpower ? true : false" @change="ecardpowerChange">电子券操作权限</el-checkbox>
                        </el-form-item> -->
                        <el-form-item label-width="0" v-if="userInfoMd.orderpower||userInfoMd.isopenfinancial" > 
                            <el-checkbox v-if="userInfoMd.orderpower" :value="checkForm.orderpower ? true : false" @change="orderpowerChange">订单权限</el-checkbox>
                            <el-checkbox v-if="userInfoMd.isopenfinancial" :value="checkForm.isopenfinancial ? true : false" @change="isopenfinancialChange">财务权限</el-checkbox>
                        </el-form-item>
                        <el-form-item label-width="0" class="onForm" v-if="checkForm.orderpower">
                            <el-checkbox  :value="checkForm.breservation ? true : false" @change="breservationChange">接受预约</el-checkbox>
                            <el-checkbox :value="checkForm.ischeckpwd ? true : false" @change="ischeckpwdChange">提货验证密码</el-checkbox>
                        </el-form-item>
                        <el-form-item label-width="0" v-if="userInfoMd.exppower ||userInfoMd.isopencardstock"> 
                            <el-checkbox v-if="userInfoMd.exppower" :value="checkForm.exppower ? true : false" @change="exppowerChange">发货权限</el-checkbox>
                            <el-checkbox v-if="userInfoMd.isopencardstock" :value="checkForm.isopencardstock ? true : false" @change="isopencardstockChange">券卡库存权限</el-checkbox>
                        </el-form-item>
                        <el-form-item label-width="0" v-if="userInfoMd.cantransferinv"> 
                            <el-checkbox v-if="userInfoMd.cantransferinv" :value="checkForm.cantransferinv ? true : false" @change="cantransferinvChange">库存调拨权限</el-checkbox>
                        </el-form-item>
                        <el-form-item label-width="0">
                          <el-button  type="primary" plain size="mini" @click="getShowChoseStore">分配门店</el-button>
                          <em class="storeEm" >已选择<b class="commonNum" @click="getShowCheckStore">{{storeList.length}}</b>家门店</em>
                        </el-form-item>
                        <!-- <div class="onForm mrb20" v-if="checkForm.exppower">
                            <el-form-item label-width="0" class="choseAreas">
                                <el-row>
                                    <el-col :span="7">
                                        <el-checkbox :value="checkForm.bassign ? true : false" @change="bassignChange">接受指派</el-checkbox>
                                    </el-col>
                                    <el-col :span="15">
                                        <el-button type="primary" plain size="mini" @click="selAreas" v-if="checkForm.bassign">{{operate == 'detail' ? '点击查看区域':'点击配置区域'}}</el-button>
                                        <em v-if="checkForm.bassign">已选择<b class="commonNum" @click="watchMoreCity">{{cityList}}</b>个区域</em>
                                    </el-col>
                                </el-row>
                            </el-form-item>
                            <el-form-item label-width="0" v-if="checkForm.exppower" class="el-form-item showOrder choseAreas">
                                <el-row>
                                    <el-col :span="8">自动指派优先级</el-col>
                                    <el-col :span="13">
                                        <el-input v-model="checkForm.assignsort" placeholder="数字越小越靠前" @input="getLimitnum('assignsort')" maxlength="9"></el-input>
                                    </el-col>
                                </el-row>
                            </el-form-item>
                        </div> -->
                    </div>   
                </el-col>
                <!--E 权限设置-->
            </el-row>
            <el-row class="mainWrap">
              <!--S 联系人-->
                <el-col :span="24">
                    <!--S 联系人-->
                    <div class="grid-content">
                        <el-form-item> 
                            <span :class="['expandTarget icondown',{'on':otherSetting}]" @click="otherSetting = !otherSetting">{{otherSetting?'点击收缩':'点击填写'}} <b>其他信息</b></span>
                        </el-form-item>
                        <div :class="['otherSetInfo',{'expanded':otherSetting}]">
                            <el-form-item label="性别">
                                <el-radio-group v-model="checkForm.sex">
                                    <el-radio :label="0">男</el-radio>
                                    <el-radio :label="1">女</el-radio>
                                    <el-radio :label="2">保密</el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="生日">
                                <el-date-picker type="date" format="yyyy - MM - dd"
                                value-format="yyyy-MM-dd" placeholder="选择日期" v-model="checkForm.birthday"></el-date-picker>
                            </el-form-item>
                            <el-form-item label="电子邮箱" prop="email"> 
                                <el-input v-model="checkForm.email" maxlength="50" clearable  placeholder="请输入电子邮箱"></el-input>
                            </el-form-item>
                            <el-form-item label="备注">
                                <el-input type="textarea" v-model="checkForm.memo" clearable placeholder="请输入备注" maxlength="100" show-word-limit></el-input>
                            </el-form-item> 
                        </div>
                    </div>
                    <!--E 联系人--> 
                </el-col>
                <!--E 联系人-->
            </el-row>
        </el-form>
        <!--E 基本信息表单-->
        <div class="bottomBtn">
            <el-button type="primary" v-if="operate != 'detail'" @click="saveFlow" :loading="isLoad">提交</el-button>
            <el-button :type="operate == 'detail' ? 'primary' : ''"  @click="$router.back(-1)">返回</el-button>
        </div>
    </section>
    <!-- S 选择门店 -->
    <StoreChose  :chosestoreDatas='storeList' :storeChoseDialogVisible="storeChoseDialogVisible" @closeChild="getCloseStoreCldd" @chosestoreData="chosestoreData"></StoreChose>
    <!-- E 选择门店 -->
    <!-- S 查看门店 -->
    <StoreCheck  :storeList="storeList" :storeCheckDialogVisible="storeCheckDialogVisible" @closeChild="getCheckStoreCld"></StoreCheck>
    <!-- E 查看门店 -->
    <!--S 可选区域组件-->
    <DeliveryArea :areaBox="optArea" :delveryCodes='checkForm.regioncode' @closeOptAreaBox="closeOptArea"></DeliveryArea>
    <!--E 可选区域组件-->
    <!--S 已选城市弹窗-->
    <RelatedCityPop :areaBox="selCityBox" :code="checkForm.regioncode" @closeSelCityBox="closeSelCity"></RelatedCityPop>
    <!--E 已选城市弹窗-->
</div>
</template>
<script>
import { Message, MessageBox } from "element-ui";
import { mapState, mapActions } from "vuex";
import api from '@/apis/api.js';
import Vue from 'vue';
export default {
    name: 'StoreManageOperate',
    data () {
        let that=this;
        return {
            flowcodes:'',
            storeList:[], //门店
            storeCheckDialogVisible:false,
            storeChoseDialogVisible:false,
            userInfoMd:'',
            operate:this.$route.params.operate,//父级页面传来的操作
            flowcode:this.$route.params.flowcode,//店员编号
            qydm:'',//企业代码
            picType:'store',//多图上传组件类型
            picList:[],//查询出的店员图片数组
            cityList:0,//选择的城市数量
            checkForm:{
                username:'',//店员账号
                pwd:'',//登录密码
                status:1?true:false,//服务状态
                linkman:'',//联系人
                sex:2,//性别
                birthday:'',//生日
                mobile:'',//手机号
                tel:'',//座机
                email:'',//邮箱
                bshow:false,//商城展示，默认展示
                showpos:'',//展示顺序
                bsharemember:false,//会员使用范围，true为仅内部使用
                issalebindcard:false,
                isopencardstock:false,
                cardpower:false,//券卡操作权限
                ecardpower:false,//电子券操作权限
                orderpower:false,//订单操作权限
                breservation:false,//是否接受预约
                ischeckpwd:false,//提货验证密码
                exppower:false,//是否开通发货权限
                bassign:false,//是否接受指派
                cantransferinv:false,//库存调拨权限
                assignsort:'',//自动指派优先级
                isopeninvoice:false,
                isopenfinancial:false,
                isopencresaler:false,
                isopenpurinvgoods:false,
                isopensale:false,
                pcdinfo:[],//地址
                addrdet:'',//详细地址
                memo:'',//备注
                picinfo:[],//上传图片
                logoimgurl:'',//图片
                regioncode:'',
                ischeckcode:false,//是否校验手机验证码
                openid:null,
                bwxlogin:null,
            }, //表单
            rules: {
                flowname: [
                    { required: true, message: '店员名称不能为空'},
                    { min: 0, max: 20, message: '长度必须在 0 到 20 之间', trigger: 'blur' }
                ],
                username: [
                    { required: true, message: '店员账号不能为空'},
                    { min: 6, max: 16, message: '长度必须在 6 到 16 之间', trigger: 'blur' }
                ],
                pwd: [
                    {required: true, message: '登录密码不能为空'},
                    { min: 6, max: 16, message: '长度必须在 6 到 16 之间', trigger: 'blur' }
                ],
                linkman: [
                    { required: true, message: '联系人不能为空'}
                ],
                pcdinfo: [
                    { required: true, message: '地址不能为空'}
                ],
                addrdet: [
                    { required: true, message: '详细地址不能为空'},
                    { min: 5, max: 50, message: '长度必须在 5 到 50 之间', trigger: 'blur' }
                ],
               mobile: [ //手机号码
                   { 
                        validator(rule,value,callback){
                            if(value===''&&that.ischeckcodeoflogin==1&&that.checkForm.ischeckcode) {
                                callback(new Error("手机号码不能为空！"));
                                return false;
                            }
                            if(that.telCheck(value,1) === 2){
                                callback(new Error("请输入合法的手机号码！"));
                            }
                        },
                        trigger: ["blur",'change']
                    },
                ],
                // tel: [ //固话号码
                //     { 
                //         validator(rule,value,callback){
                //             if(that.telCheck(value,2) === 2){
                //                 callback(new Error("请输入合法的固话号码！"));
                //             }
                //         },
                //         trigger: "blur" 
                //     },
                // ],
                email: [ //电子邮箱
                    { 
                        validator(rule,value,callback){
                            if(that.emailCheck(value) === 2){
                                callback(new Error("请输入合法的电子邮箱！"));
                            }
                        },
                        trigger: "blur" 
                    },
                ],
            },
            optArea:false, //可选配送区域弹窗
            selCityBox:false, //已选城市弹窗
            otherSetting:false, //其他设置默认隐藏
            isLoad:false,//加载中
            ischeckcodeoflogin: 0, // 是否开通验证码验证
            showPassword: false, // 是否显示切换密码图标
        }
    },
    watch: {
        'checkForm.pwd'(val) {
            if(val) {
                this.showPassword = true;
            }
        }
    },
    //-------------------------------------------------------计算属性------------------------------------------//
    computed: {
        // ...mapState({
        //     bannerPicList:({ goodsStore }) => goodsStore.goodsImgList, // 轮播图上传图片列表
        // })
    },
    components: {
        StoreChose: resolve =>require(["@/components/CardsFolder/StoreChose.vue"], resolve), //选择门店
        StoreCheck: resolve =>require(["@/components/CardsFolder/StoreCheck.vue"], resolve), //查看门店
        DeliveryArea: resolve => require(["@/components/common/DeliveryArea.vue"],resolve), //可选配送区域组件
        ProvincesOrCity: resolve =>require(["@/components/common/ProvincesOrCity.vue"], resolve),//省市区选择
        RelatedCityPop: resolve => require(["@/components/common/RelatedCityPop.vue"],resolve), // 关联城市弹窗组件
    },
    methods: {
      // 关闭查看门店弹窗
      getCheckStoreCld() {
          this.storeCheckDialogVisible = false;
      },
      //门店数据
      chosestoreData(type){
        this.storeList = type;
        let parm ='';
        if(type.length>0){
          type.map((item,index)=>{
              if(index!=0){
                  parm += '#';
              }
              parm += item.flowcode;
          })
        }
         this.flowcodes = parm;
      },
      // 关闭选择门店弹窗
      getCloseStoreCldd() {
        this.storeChoseDialogVisible = false;
      },
        // 打开选择门店弹窗
        getShowChoseStore() {
          this.storeChoseDialogVisible = true;
        },
        getShowCheckStore() {
            this.storeCheckDialogVisible = true;
        },
        // 设置图片
        setImage(val) {
            this.checkForm.logoimgurl = val;
        },
        // 图片、视频上传和成功的遮罩显隐
        getLoad(val){
            if(val){
                this.isLoad = true;
            }else{
                this.isLoad = false;
            }
        },
        // 正整数校验
        getLimitnum(type){
            if(type == 'showpos'){
                this.checkForm.showpos = this.integerCheck(this.checkForm.showpos);
            }else if(type == 'assignsort'){
                this.checkForm.assignsort = this.integerCheck(this.checkForm.assignsort);
            }
        },
        // 流向方账号重复性校验
        checkFlowUsername(){
            if(this.checkForm.username){
                if(this.checkForm.username.length < 6 || this.checkForm.username.length > 16){
                    this.$message.error('账号长度必须在 6 到 16 之间！');
                    return false;
                }
                let params = {
                    username:this.qydm + this.checkForm.username
                }
                if(this.flowcode){
                    params.flowcode = this.flowcode
                }
                api.CHECKFLOWUSERNAME(params).then((res) => {
                    if(res.data.data){
                        // this.$message.success(res.data.message)
                    }else{
                        this.$message.error(res.data.message)
                    }
                })
            }
        },
        // 流向名称重复性校验
        checkFlowname(){
            if(this.checkForm.flowname){
                let params = {
                    flowname:this.checkForm.flowname,
										objtype:6,
                }
                if(this.flowcode){
                    params.flowcode = this.flowcode
                }
                api.CHECKFLOWNAME(params).then((res) => {
                    if(res.data.data){
                        // this.$message.success(res.data.message)
                    }else{
                        this.$message.error(res.data.message)
                    }
                })
            }
        },
        issalebindcardChange(val){
          this.checkForm.issalebindcard = val;
        },
        isopencardstockChange(val){
          this.checkForm.isopencardstock = val;
        },
        // 切换状态
        statusChange(val){
            this.checkForm.status = val;
        },
        // 是否商城展示
        bshowChange(val){
            this.checkForm.bshow = val;
        },
        // 是否查看企业所有会员
        bsharememberChange(val){
            this.checkForm.bsharemember = val;
        },
        // 券卡操作权限
        cardpowerChange(val){
            this.checkForm.cardpower = val;
        },
        // 电子券操作权限
        ecardpowerChange(val){
            this.checkForm.ecardpower = val;
        },
        // 订单权限
        orderpowerChange(val){
            this.checkForm.orderpower = val;
        },
        // 接受预约
        breservationChange(val){
            this.checkForm.breservation = val;
        },
        // 提货验证
        ischeckpwdChange(val){
            this.checkForm.ischeckpwd = val;
        },
        // 发货权限
        exppowerChange(val){
            this.checkForm.exppower = val;
        },
        // 接受指派
        bassignChange(val){
            this.checkForm.bassign = val;
        },
        cantransferinvChange(val){
            this.checkForm.cantransferinv = val;
        },
        isopeninvoiceChange(val){
           this.checkForm.isopeninvoice = val;
        },
        isopenfinancialChange(val){
           this.checkForm.isopenfinancial = val;
        },
        isopenpurinvgoodsChange(val){
           this.checkForm.isopenpurinvgoods = val;
        },
        isopencresalerChange(val){
           this.checkForm.isopencresaler = val;
        },
        isopensaleChange(val){
           this.checkForm.isopensale = val;
        },
        
        //打开可选区域弹窗
        selAreas(){
            
            this.optArea = true;
        },
        //关闭可选区域弹窗
        closeOptArea(index,type,types){
            if(index==1){
                this.checkForm.regioncode = type;
                this.cityList= types;
            }
            this.optArea = false;
        },
        //查看已选城市弹窗
        watchMoreCity(){
            if(this.cityList>0){
                this.selCityBox = true;
            }
        },
        //关闭已选城市弹窗
        closeSelCity(){
            this.selCityBox = false;
        },
        // 获取详情
        getFlowDetail(){
            this.isLoad = true;
            api.GET_FLOWDETAIL({flowcode:this.flowcode}).then((res) => {
                if(res.data.status == "200"){
                    this.isLoad = false;
                    let pics = [];
                    let checkData = res.data.data;
                    let qydmLgth = this.qydm.length;
                    this.checkForm = {
                        flowname:checkData.flowname,//店员名称
                        username:checkData.username.substr(qydmLgth),//店员账号
                        pwd:checkData.pwd,//登录密码
                        status:checkData.status,//服务状态
                        linkman:checkData.linkman,//联系人
                        sex:checkData.sex,//性别
                        birthday:checkData.birthday,//生日
                        mobile:checkData.mobile,//手机号
                        tel:checkData.tel,//座机
                        email:checkData.email,//邮箱
                        bsharemember:checkData.bsharemember,//会员使用范围，true为仅内部使用
                        cardpower:checkData.cardpower,//券卡操作权限
                        ecardpower:checkData.ecardpower,//电子券操作权限
                        issalebindcard:checkData.issalebindcard,
                        isopencardstock:checkData.isopencardstock,
                        orderpower:checkData.orderpower,//订单操作权限
                        breservation:checkData.breservation,//是否接受预约
                        ischeckpwd:checkData.ischeckpwd,//提货验证密码
                        exppower:checkData.exppower,//是否开通发货权限
                        bassign:checkData.bassign,//是否接受指派
                        cantransferinv:checkData.cantransferinv,
                        assignsort:checkData.assignsort,//自动指派优先级
                        isopenfinancial:checkData.isopenfinancial,
                        isopeninvoice:checkData.isopeninvoice,
                        isopencresaler:checkData.isopencresaler,
                        isopenpurinvgoods:checkData.isopenpurinvgoods,
                        isopensale:checkData.isopensale,
                        pcdinfo:[{
                            name: res.data.data.province,
                            code: res.data.data.provincecode
                        },
                        {
                            name: res.data.data.city,
                            code: res.data.data.citycode
                        },
                        {
                            name: res.data.data.district,
                            code: res.data.data.districtcode
                        }],//地址
                        addrdet:checkData.addrdet,//详细地址
                        memo:checkData.memo,//备注
                        // picinfo:[],//上传图片
                        logoimgurl:checkData.mainpiclink,
                        regioncode:'',
                        ischeckcode: checkData.ischeckcode==1?true:false,
                        openid:checkData.openid,
                        bwxlogin:checkData.bwxlogin,
                    } //表单
                    if(this.operate != 'add'){
                        this.checkForm.pwd = '';
                    }
                    api.GETFLOWONFOOFBINDLIST({pflowcode:checkData.flowcode}).then(res=>{
                      if(res.data.status=="200"){
                          this.storeList = res.data.data;
                          this.chosestoreData(this.storeList)
                      }else{
                          this.storeList = [];
                      }
                    })
                    // if(res.data.data.mainpiclink && res.data.data.mainpiclink != null){
                    //     this.picList.push(res.data.data.mainpiclink);
                    // }
                    // if(res.data.data.picinfo && res.data.data.picinfo != null){
                    //     let picinfo = res.data.data.picinfo;
                    //     if(!picinfo.includes("@")){
                    //         this.checkForm.picinfo = res.data.data.picinfo;
                    //         this.picList.push(res.data.data.picinfo);
                    //     }else{
                    //         picinfo = picinfo.split("@");
                    //         picinfo.map(item => {
                    //             pics.push(item);
                    //             this.picList.push(item);
                    //         })
                    //         this.checkForm.picinfo = pics;
                    //     }
                    // }
                    if(res.data.data.regioncode){
                        let regioncode = res.data.data.regioncode.split("@");
                        this.cityList= regioncode.length;
                        this.checkForm.regioncode = regioncode.join(",")
                    }
                }else{
                    this.$message.error('获取详情信息失败！')
                }
            })
        },
        // 提交
        saveFlow(){
            if(!this.checkForm.username){
                this.$message.error('店员账号不能为空！');
                return false
            }
            if(this.operate == 'add'){
                if(!this.checkForm.pwd){
                    this.$message.error('店员密码不能为空！');
                    return false
                }
            }
            if(!this.checkForm.pcdinfo || this.checkForm.pcdinfo.length == 0){
                this.$message.error('地址不能为空！');
                return false
            }
            if(this.checkForm.addrdet == ''){
                this.$message.error('详细地址不能为空！');
                return false
            }
            if(this.checkForm.addrdet){
                if(this.checkForm.addrdet.length < 5 || this.checkForm.addrdet.length > 50){
                    this.$message.error('详细地址长度必须在 5 到 50 之间');
                    return false
                }
            }
            if(!this.checkForm.linkman){
                this.$message.error('联系人不能为空！');
                return false
            }
            if(this.ischeckcodeoflogin&&this.checkForm.ischeckcode&&this.checkForm.mobile==='') {
                this.$message.error('手机号码不能为空！');
                return false
            }
            if(!this.checkForm.mobile && !this.checkForm.tel){
                this.$message.error('手机号码和固话号码至少填写一个！');
                return false
            }
            // if(this.checkForm.mobile){
            //     if(this.telCheck(this.checkForm.mobile,1) === 2){
            //         this.$message.error("请输入合法的手机号码！");
            //         return false
            //     }
            // }
            // if(this.checkForm.tel){
            //     if(this.telCheck(this.checkForm.tel,2) === 2){
            //         this.$message.error("请输入合法的固话号码！");
            //         return false
            //     }
            // }
            if(this.checkForm.email){
                if(this.emailCheck(this.checkForm.email) == 2){
                    this.$message.error("请输入合法的电子邮箱！");
                    return false
                }
            }
            // let picinfo = [];
            // this.bannerPicList.map((item,index) => {
            //     if(index != 0){
            //         picinfo.push(item)
            //     }else{
            //         this.checkForm.mainpiclink = item;
            //     }
            // });
            // this.checkForm.picinfo = picinfo.join("@");
            let regioncodes = '';
            if(this.checkForm.regioncode){
                 let regioncode = this.checkForm.regioncode.split(",");
                 regioncodes = regioncode.join("@")
            }   
            let params = {
                addtype:0,//0：完整新增 1：精简新增
                objtype:6,//0:店员；1：发货网点；2：一级分销；4：微店员；5：企业微店员
                username:this.qydm + this.checkForm.username,
                pwd:this.checkForm.pwd,
                status:this.checkForm.status ? 1 : 0,
                linkman:this.checkForm.linkman,
                sex:Number(this.checkForm.sex),
                birthday:this.checkForm.birthday,
                mobile:this.checkForm.mobile,
                tel:this.checkForm.tel,
                email:this.checkForm.email,
                bshow:this.checkForm.bshow ? 1 : 0,
                showpos:Number(this.checkForm.showpos),
                // bsharemember:this.checkForm.bsharemember ? 1 : 0,
                orderpower:this.checkForm.orderpower ? 1 : 0,
                ischeckpwd:this.checkForm.ischeckpwd ? 1 : 0,
                breservation:this.checkForm.breservation ? 1 : 0,
                cardpower:this.checkForm.cardpower ? 1 : 0,
                ecardpower:this.checkForm.ecardpower ? 1 : 0,
                issalebindcard:this.checkForm.issalebindcard ? 1 : 0,
                isopencardstock:this.checkForm.isopencardstock ? 1 : 0,
                exppower:this.checkForm.exppower ? 1 : 0,
                // bassign:this.checkForm.bassign ? 1 : 0,
                cantransferinv:this.checkForm.cantransferinv ? 1 : 0,
                mainpiclink:this.checkForm.logoimgurl,
                provincecode:this.checkForm.pcdinfo[0].code,
                province:this.checkForm.pcdinfo[0].name,
                citycode:this.checkForm.pcdinfo[1].code,
                city:this.checkForm.pcdinfo[1].name,
                districtcode:this.checkForm.pcdinfo[2].code,
                district:this.checkForm.pcdinfo[2].name,
                addrdet:this.checkForm.addrdet,
                memo:this.checkForm.memo,
                // regioncode:regioncodes,
                isopenfinancial:this.checkForm.isopenfinancial?1:0,
                isopeninvoice:this.checkForm.isopeninvoice?1:0,
                isopencresaler:this.checkForm.isopencresaler?1:0,
                isopenpurinvgoods:this.checkForm.isopenpurinvgoods?1:0,
                isopensale:this.checkForm.isopensale?1:0,
                ischeckcode: this.checkForm.ischeckcode?1:0
            }
            if(this.operate == 'edit'){
                params.flowcode = this.flowcode
            }
            // if(this.checkForm.picinfo && this.checkForm.picinfo.length > 0){
            //     params.picinfo = this.checkForm.picinfo
            // }
            // if(this.checkForm.bassign){
            //     params.assignsort = this.checkForm.assignsort
            // }
            this.isLoad = true;
            api.SAVEFLOW(params).then((res) => {
                if(res.data.status == "200"){
                    let flowcode = res.data.data;
                     api.BINDFLOWINFOS({flowcode:flowcode,flowcodes:this.flowcodes}).then(res =>{
                       if(res.data.status == "200"){
                           this.$message.success(res.data.message);
                          this.$router.push({
                              path:'/ShopSalesman'
                          })
                       }else{
                         this.$message.success(res.data.message);
                       } 
                      })
                }else{
                    this.$message.error(res.data.message);
                }
                this.isLoad = false;
            })
        },
    },
    created() {
    },
    mounted(){
      if(localStorage.getItem('userInfoMd') && localStorage.getItem("userInfoMd") != 'null' && localStorage.getItem("userInfoMd") != 'undefined'){
            this.userInfoMd = JSON.parse(localStorage.getItem("userInfoMd"));
            if(this.userInfoMd.bsharemember){
               this.checkForm.bsharemember = false;
            }
            if(this.userInfoMd.cardpower){
               this.checkForm.cardpower = false;
            }
            if(this.userInfoMd.ecardpower){
               this.checkForm.ecardpower = false;
            }
            if(this.userInfoMd.orderpower){
               this.checkForm.orderpower = false;
            }
            if(this.userInfoMd.exppower){
               this.checkForm.exppower = false;
            }
            if(this.userInfoMd.isopeninvoice){
               this.checkForm.isopeninvoice = false;
            }
            if(this.userInfoMd.isopenfinancial){
               this.checkForm.isopenfinancial = false;
            }
            if(this.userInfoMd.isopencresaler){
               this.checkForm.isopencresaler = false;
            }
            if(this.userInfoMd.isopenpurinvgoods){
               this.checkForm.isopenpurinvgoods = false;
            }
            if(this.userInfoMd.isopensale){
               this.checkForm.isopensale = false;
            }
      }
      // 是否开通登录短信验证
        this.ischeckcodeoflogin = this.ElementControls('ischeckcodeoflogin');
        if(this.operate != 'add'){
            this.getFlowDetail();//获取详情
        }
        // 获取企业代码
        let cmpyinfo = localStorage.getItem("cmpyinfo");
        if(cmpyinfo && cmpyinfo != 'null' && cmpyinfo != 'undefined'){
            this.qydm = JSON.parse(cmpyinfo).qydm;
        }
    },
}
</script>
<style scoped>
@import '../../GoodsFolder/Css/style.css';
@import '../Css/style.css';
/* .mainWrap{width: 80%;}
@media only screen and (max-width: 1600px) {
  .mainWrap{width: 100%}
} */
.expandTarget {position:relative;font-size: 12px; color:#999; cursor: pointer;}
.expandTarget b {color:var(--main-color);}
.expandTarget:before {position: absolute; left:110px; -webkit-transition:transform .2s;-moz-transition:transform .2s;-ms-transition:transform .2s;-o-transition:transform .2s; transition:transform .2s;}
.expandTarget.on:before {-webkit-transform:rotate(180deg);-moz-transform:rotate(180deg);-ms-transform:rotate(180deg);-o-transform:rotate(180deg);transform:rotate(180deg);}
.otherSetInfo {max-height:0; overflow:hidden; -webkit-transition:max-height .2s;-moz-transition:max-height .2s;-ms-transition:max-height .2s;-o-transition:max-height .2s;transition:max-height .2s;}
.otherSetInfo.expanded {max-height: 300px;}
.uploadBox >>> .operateCover {display:block;position:absolute; z-index:999; width:100%; bottom:0; background:rgba(0,0,0,.7); text-align: center; width:100%; }
.uploadBox >>> .operateCover i {display:inline-block; font-size:24px; color:#fff; margin: 0 10px;}
 
.onForm>>>.el-form-item__content{background: #f5f5f5;padding-left:20px;}
.onForm .el-form-item.choseAreas{margin-bottom:0;}
.onForm .choseAreas>>>.el-form-item__content{padding-bottom:22px;}
.onForm .showOrder>>>.el-form-item__content{padding-bottom:10px;}
/* .choseAreas .el-button{
    padding: 6px 6px;
    font-size: 12px;
    color: var(--main-color);
    border: 1px solid var(--main-color);
} */
.choseAreas em{
  color: #999;
  font-size: 12px;
  cursor: pointer;
  margin-left: 5px;
}
.choseAreas em b{
  font-weight: bold;
  color: #F7615E;
  margin: 0 5px;
  font-size: 14px;
}
.fixNum {
  width:100%;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  padding-left: 10px;
  -webkit-box-sizing:  border-box;
  -moz-box-sizing: border-box;
  -o-box-sizing: border-box;
  -ms-box-sizing: border-box;
  box-sizing: border-box;
  display: inline-block;
}
.fixBg{
  background: #F5F7FA;
}
.fixNum .el-input {
  display: inline-block;
  width: 80%;
}
.fixNum>>>.el-input__inner {
  border: none;
  border-radius: 0;
  padding-left: 5px;
}
.fixNum span {
  color: #333;
}
.pink{color: #F56C6C;padding: 0 5px;}
.iconwh.pa{left: 160px;top: 55px;}
.mainDet {height:calc(100% - 169px);}
.allWidth >>> .el-form-item__content{width: 100%; max-width: 100%;}
.allWidth >>> .el-form-item__content .el-input {width: 130px;}
.allWidth .pl10 {padding-left: 10px;}
.mrb20 {margin-bottom: 20px;}
/* .storeBtn{    
    padding: 6px;
    font-size: 12px;
    color: var(--main-color);
    border: 1px solid var(--main-color);
} */
.storeEm{
    color: #999;
    font-size: 12px;
    cursor: pointer;
    margin-left: 5px;
}
.storeEm b {
    font-weight: 700;
    color: #f7615e;
    margin: 0 5px;
    font-size: 14px;
}
</style>


// WEBPACK FOOTER //
// src/views/ManageFolder/ManageJsz/ShopAddsalesman.vue